export const fontFamily = {
  helvetica: "Helvetica",
  openSans: "Open-Sans",
  poppins: "Poppins",
  lato: "Lato",
  roboto: "Roboto",
  spartan: "Spartan",
  jost: "Jost",
  urbanist: "Urbanist",
} as const;

export type FontFamilyType = typeof fontFamily;
